import { API_BASE_URL } from "./api.base";

export const ENDPOINTS = {
  competitions: {
    myCompetitions: `${API_BASE_URL}/competitions/my-competitions/`,
    myTournaments: `${API_BASE_URL}/competitions/my-tournaments/`,
    // Tenant-scoped Series list — used by the Match Edit form to attach
    // a match to a bilateral series instead of a competition.
    mySeries:       `${API_BASE_URL}/competitions/my-series/`,
    // Per-tenant folder catalog. Feeds the folder dropdown on the
    // Tournament add/edit form.
    tournamentFolders: `${API_BASE_URL}/competitions/tournament-folders/`,
  },
  matches: {
    matchTypes: `${API_BASE_URL}/matches/matchtypes/`,
  },
  coredata: {
    teams: `${API_BASE_URL}/coredata/my-teams/`,
    stadiums: `${API_BASE_URL}/coredata/my-stadiums/`,
    umpires: `${API_BASE_URL}/coredata/my-umpires/`,
    nationalities: `${API_BASE_URL}/coredata/nationalities/`,
  },
};
